export class SessionConnectingAction {
  static readonly type = '[Session] connecting to server stream';
}
